// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fundoPesquisa {\n  display: flex;\n  padding: 0.5rem 0.5rem;\n  list-style: none;\n  border-radius: 0.375rem;\n  background-color: #ffffff;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n.itemPesquisa {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.mr-sm-3,\n.mx-sm-3 {\n  margin-right: 1rem !important;\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
